import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import React from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import { TeacherClassDto } from "../../../../interfaces";

type TProps = {
  classes: TeacherClassDto[];
  show: boolean;
  onCloseClick: (event: any) => void;
};
export const TeacherClassesModal: React.FC<TProps> = ({
  classes,
  show,
  onCloseClick,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal states

  //#endregion

  //#endregion

  //#region handlers
  const onClose = () => {
    onCloseClick(!show);
  };

  //#endregion

  return (
    <React.Fragment>
      <ToastContainer />
      <Modal
        size="lg"
        id="classes"
        isOpen={show}
        toggle={() => {
          onClose();
        }}
        centered
      >
        <ModalHeader
          className="p-3"
          toggle={() => {
            onClose();
          }}
        >
          {t("classes")} {`(${classes.length})`}
        </ModalHeader>
        <ModalBody>
          <Row>
            {classes.map((teacherClass: TeacherClassDto, index: number) => (
              <Col lg={4} className="py-2">
                <Row>
                  <Col>
                    <div className="text-center">
                      <div className="team-content pt-2">
                        <h3 className="fs-16 mb-1">
                          {i18n.language === "ar"
                            ? teacherClass.name?.ar
                            : teacherClass.name?.en}
                        </h3>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
